<template lang="pug">

.nav-wrapper
  #menu(:class="{'repair-mode': changeHeaderForRepairMode }")
    header
      #toggle(@click="toogleBurger()")
        #top.span(:class="{active: isMobileMenuOpen}")
        #middle.span(:class="{active: isMobileMenuOpen}")
        #bottom.span(:class="{active: isMobileMenuOpen}")
      aiq-menu.main-toolbar(mode="horizontal" menu-trigger="click" ref="headerMenuItem" :ellipsis="false" @open="showProfileTooltip = false" @close="showProfileTooltip = true")
        template(v-if="!tutorialInProgress")
          aiq-menu-item.main-toolbar_item(:index="menuIndex('conversations')" v-if="canAccessRoute('/conversations')")
            router-link(v-if="newConversationIndicator", to="/conversations", tag="div", class="unread-message button-glow", @click="onNewConversationIndicatorClick")
              .unread-message-indicator
            router-link(to="/conversations")
              font-awesome-icon.iq-ico-toolbar(icon="messages" :class="{'glow-ico-message': newConversationIndicator}")
              | Conversations
          aiq-menu-item.main-toolbar_item(:index="menuIndex('customers')" v-if="canAccessRoute('/customers')")
            router-link(to="/customers")
              font-awesome-icon.iq-ico-toolbar(icon="users")
              | {{ $t('top_nav.customer_tab') }}
          aiq-menu-item.main-toolbar_item(:index="menuIndex('agents')" v-if="canAccessRoute('/users')")
            router-link(to="/users")
              font-awesome-icon.iq-ico-toolbar(icon="user-headset")
              | Agents
          aiq-menu-item.main-toolbar_item(:index="menuIndex('iqtools')" v-if="canAccessRoute('/iqtools')")
            router-link(to="/iqtools")
              font-awesome-icon.iq-ico-toolbar(icon="microchip-ai")
              | IQ Tools
          aiq-menu-item.main-toolbar_item(:index="menuIndex('settings')" v-if="canAccessRoute('/settings')")
            router-link(to="/settings")
              font-awesome-icon.iq-ico-toolbar(icon="gear")
              | Settings
          aiq-menu-item.main-toolbar_item(:index="menuIndex('metrics')" v-if="canAccessRoute('/metrics')")
            router-link(to="/metrics")
              font-awesome-icon.iq-ico-toolbar(icon="chart-line")
              | Metrics
          aiq-menu-item.main-toolbar_item(:index="menuIndex('pulse')" v-if="canAccessRoute('/pulse')")
            router-link(to="/pulse")
              font-awesome-icon.iq-ico-toolbar(icon="timer")
              | Pulse
          aiq-menu-item.main-toolbar_item(:index="menuIndex('compliance')" v-if="canAccessRoute('/compliance')")
            router-link(to="/compliance")
              font-awesome-icon.iq-ico-toolbar(icon="file-lines")
              | Reporting

        aiq-menu-item.logo-dropdown-container
          aiq-image.aiq-logo(:src="aiqLogo")

        aiq-menu-item.mobileNavPageName
          span.contextNavText {{ $t(contextNavText) }}

        aiq-menu-item.main-toolbar_item.agent-status-menu.sub-status
          template(v-slot:title)
            aiq-status-indicator(:status="selectedAgentStatus ? selectedAgentStatus.status : ''" :show-all-states="true")
          aiq-tooltip(placement="bottom"
                      effect="dark"
                      :content="$t('top_nav.drop_down.status')"
                      :show-after="500"
                      :disabled="agentStateVisible")
            aiq-select(v-model="selectedAgentStatus"
                      :filterable="false"
                      value-key="id"
                      popper-class="agent-status-dropdown"
                      :teleported="false"
                      size="large"
                      placeholder="Select a status"
                      :suffix-icon="Icon.CaretBottom"
                      @visible-change="onVisibilityChanged"
                      @click="onAgentStatusClick")
              aiq-option(v-for="item in dropdownStatusOptions",
                        :key="item.id",
                        :label="item.label",
                        :value="item")
                agent-status(:available="item.status" :subStatus="item.subStatus" :show-label="true")
              aiq-option(key="logout" value="logout" @click="logout" class="besek")
                font-awesome-icon(icon="arrow-right-from-bracket" size="xl")
                | {{ $t('top_nav.drop_down.logout')}}

        aiq-menu-item.icon-container(:index="menuIndex('jumpTo')" v-if="canView('/header/lynq_to_button')" @click="showJumpToUI")
          aiq-tooltip(placement="bottom"
                      effect="dark"
                      :content="$t('top_nav.lynq_to_button.tooltip')"
                      :show-after="500")
            font-awesome-icon.arrow-right(icon="arrow-right-to-bracket")

        aiq-menu-item.icon-container(:index="menuIndex('themeToggle')" v-if="isDarkThemeSupported")
          theme-toggle(@theme-changed="onThemeChanged")
        aiq-menu-item.icon-container(:index="menuIndex('scheduling')" v-if="shouldDisplaySchedulingJob" @click="showSchedulingJob")
          aiq-tooltip(placement="bottom"
                  effect="dark"
                  :content="$t('top_nav.drop_down.calendar')"
                  :show-after="500")
            font-awesome-icon.calendar(icon="calendar-days")

        aiq-menu-item.icon-container(:index="menuIndex('notification')" v-if="FEATURE_FLAGS.ENABLE_NOTIFICATION")
          aiq-tooltip(placement="bottom"
                      effect="dark"
                      :content="$t('top_nav.drop_down.notification')"
                      :show-after="500")
            .notification-button(@click="onNotificationClick")
              .notification-badge(v-if="notifications.unread_count > 0")
                aiq-badge(:value="notifications.unread_count")
              font-awesome-icon.notification-icon(icon="bell")
        aiq-tooltip(placement="bottom"
                effect="dark"
                :content="$t('top_nav.drop_down.profile')"
                :show-after="500"
                :disabled="!showProfileTooltip")
          aiq-sub-menu(:index="menuIndex('profile')"
                      :teleported="true"
                      v-click-away="onCloseProfileSubMenu"
                      popper-class="agent-profile-dropdown").dropdown
            template(v-slot:title)
              aiq-button
                aiq-image(:src="avatar" :key="avatar")
                agent-status.avatar-status-indicator(v-if="selectedAgentStatus" :available="selectedAgentStatus?.status" :subStatus="selectedAgentStatus?.subStatus")
                span.profile-name {{ firstName }} {{ lastName }}
            aiq-menu-item(:index="menuIndex('profileMyAccount')" @click="showProfileEditor")
              font-awesome-icon(icon="circle-user" size="xl")
              | {{ $t('top_nav.drop_down.my_account')}}
            aiq-menu-item(:index="menuIndex('profileSettings')" v-if="shouldDisplaySettingsMenuItem" @click="showSettings")
              i.el-icon-setting
              | {{ $t('top_nav.drop_down.settings')}}
            aiq-menu-item(:index="menuIndex('profileTutorial')" v-if="shouldDisplayTutorialMenuItem" @click="redisplayTutorial")
              TutorialIcon
              span.tutorial-text
                | {{ $t('top_nav.drop_down.tutorial')}}
            aiq-menu-item(:index="menuIndex('profileMyPerformance')" v-if="shouldDisplayMyPerformance")
              router-link(to="/my/performance")
                font-awesome-icon(icon="trophy-star" size="xl")
                | {{ $t('top_nav.drop_down.my_performance')}}
            aiq-menu-item(:index="menuIndex('profileReleaseNotes')" v-if="shouldDisplayReleaseNotesLink" @click="openReleaseNotesLink")
                font-awesome-icon(icon="folder-magnifying-glass" size="xl")
                | {{ $t('top_nav.drop_down.lynq_portal')}}
            aiq-menu-item(:index="menuIndex('profileLogout')" @click="logout")
              font-awesome-icon(icon="arrow-right-from-bracket" size="xl")
              | {{ $t('top_nav.drop_down.logout')}}

      aiq-drawer(:model-value="isMobileMenuOpen"
                direction="ttb"
                close-on-click-modal
                :show-close="false"
                :with-header="false"
                class="mobile-menu-drawer"
                :before-close="closeMobileMenu"
                default-active)
        aiq-menu(mode="vertical" @click="closeMobileMenu")
          aiq-menu-item(:index="menuIndex('conversations')" @click="goTo('/conversations')" v-if="canAccessRoute('/conversations')") Conversations
          aiq-menu-item(:index="menuIndex('customers')" @click="goTo('/customers')" v-if="canAccessRoute('/customers')") {{ $t('top_nav.customer_tab') }}
          aiq-menu-item(:index="menuIndex('users')" @click="goTo('/users')" v-if="canAccessRoute('/users')") Agents
          aiq-menu-item(:index="menuIndex('iqtools')" @click="goTo('/iqtools')" v-if="canAccessRoute('/iqtools')") IQ Tools
          aiq-menu-item(:index="menuIndex('settings')" @click="goTo('/settings')" v-if="canAccessRoute('/settings')") Settings
          aiq-menu-item(:index="menuIndex('metrics')" @click="goTo('/metrics')" v-if="canAccessRoute('/metrics')") Metrics
          aiq-menu-item(:index="menuIndex('pulse')" @click="goTo('/pulse')" v-if="canAccessRoute('/pulse')") Pulse
          aiq-menu-item(:index="menuIndex('compliance')" @click="goTo('/compliance')" v-if="canAccessRoute('/compliance')") Reporting
          aiq-menu-item(:index="menuIndex('jumpTo')" v-if="canView('/header/lynq_to_button')" @click="showJumpToUI") Lynq To
          aiq-menu-item(:index="menuIndex('scheduling')" v-if="shouldDisplaySchedulingJob" @click="showSchedulingJob") {{ $t('top_nav.drop_down.calendar') }}
          aiq-menu-item(:index="menuIndex('notification')" v-if="FEATURE_FLAGS.ENABLE_NOTIFICATION" @click="onNotificationClick") {{ $t('top_nav.drop_down.notification') }}
          aiq-menu-item(:index="menuIndex('queue_status')" @click="openSetStatusDialog") Queue Status

  aiq-dialog(title="Please select a status"
            :model-value="showSetStatusDialog"
            width="25%"
            :show-close="false"
            :close-on-press-escape="false")
    aiq-select(v-model="selectedAgentStatus"
              :filterable="false"
              value-key="id"
              size="large"
              placeholder="Select a status"
              :suffix-icon="Icon.CaretBottom"
              @change="handleInitialStatusSelect")
      aiq-option(v-for="item in dropdownStatusOptions",
                :key="item.id",
                :label="item.label",
                :value="item")
        agent-status(:available="item.status" :subStatus="item.subStatus" :show-label="true")

  agent-editor(v-if="profileEditorVisible"
              :afterClose="closeProfileEditor"
              :buttons="['save', 'close']"
              resource="/settings/agents/profile")

  aiq-dialog(:title="$t('top_nav.lynq_to_button.dialog_title')"
            :model-value="showJumpToPopUp"
            :before-close="handleBeforeClose"
            :close-on-click-modal="true"
            :close-on-press-escape="true"
            :show-close="true")
    template(v-for="field in jumpToFields" :key="field.key")
      .dialog-content {{ $t(field.label) }}
      aiq-input(
        :placeholder="$t(field.placeholder)"
        v-model="jumpTo[field.key]"
        class="lynq-input"
        :type="field.type"
        @keyup.enter="goToConversation"
        :disabled="getIsJumpToFilterDisabled(field.key)")
    template(v-slot:footer)
      .dialog-footer
        aiq-button(@click="closeJumpToUI") {{ $t('top_nav.lynq_to_button.cancel')}}
        aiq-button(@click="goToConversation" :disabled="isGoToConversationDisabled" type="primary" class="lynq_id_button") {{ $t('top_nav.lynq_to_button.lynq')}}

  aiq-dialog(:title="$t('top_nav.lynq_to_button.conversation.title')"
            :model-value="showConversationCreation"
            :before-close="handleConvBeforeClose"
            :close-on-click-modal="true"
            :close-on-press-escape="true"
            :show-close="true")
    .phone-content {{ $t('top_nav.lynq_to_button.conversation.not_found')}}
    .phone-content(v-if="canEdit('/global/lynqto/phone')") {{ $t('top_nav.lynq_to_button.conversation.create_conv')}}
    .dialog-conv-footer
      aiq-button(@click="closeConversationCreation") {{ $t('global.cancel')}}
      aiq-button(v-if="canEdit('/global/lynqto/phone')" @click="createConversation" type="primary" class="lynq_id_button") {{ $t('global.yes')}}

  .notification-dialog
    aiq-dialog.modal-editor(:title="notificationMsgTitle",
                            :model-value="!!notificationItemOnPopup"
                            :show-close="false")
      .body
        .customer-reference(v-if="hasCustomerInNotification")
          h5.label Customer
          aiq-button.value(link type="primary" @click="goToCustomerConversation") {{ customerNameInNotification }}
        h5 Message
        br
        p(v-html="notificationMsg")

      template(v-slot:footer)
        aiq-button(@click="notificationItemOnPopup = null") Close
  dropdown(v-if="FEATURE_FLAGS.ENABLE_NOTIFICATION"
          :options="notifications.items"
          :show="showNotification"
          :totalCount="notificationPagination.rowCount"
          ref="notificationDropdown"
          @readall="onReadAllNotifications"
          @delete="onDeleteNotification"
          @bottom="onNextNotifications"
          @select="onSelectNotification"
          @close="onCloseNotification")
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import get from 'lodash/get';
import assign from 'lodash/assign';
import has from 'lodash/has';
import { email } from '@vuelidate/validators';
import { DEFAULT_SCOPE, DEFAULT_POLL_INTERVAL, FIXED_AGENT_STATUS } from '@/constants';
import { defaultProfile, getCustomerName } from '@/libs';
import aiqLogo from '@/assets/agentiq-logo.png';
import agentEditor from '@/pages/Settings/Agents/children/Manage/Edit.vue';
import AgentStatus from '@/components/AgentStatus.vue';
import TutorialIcon from '@/assets/svg/tutorial.vue';
import Dropdown from '@/components/notificationDropdown.vue';
import ThemeToggle from '@/components/ThemeToggle/ThemeToggle.vue';
import { PAGINATION_DEFAULT } from '@/constants/pagination';
import { AGENT_ONBOARDING, SCHEDULE_TYPE, NOTIFICATIONS } from '@/constants/analytics';
import { confirmBeforeDialogClose, isAgentIqEmailAddress } from '@/libs';
import { removeCurrentTab } from '@/libs/tabManager';

const NOT_FOUND = 404;

const MENU_INDEX_PREFIX = 'menu-item-';
const PAGINATION_NOTIFICATION_DEFAULT = assign({}, PAGINATION_DEFAULT, { limit: 10 });
const NOTIFICATION_TYPE = {
  CUSTOMER: 'customer',
  AGENT: 'agent',
  SYSTEM: 'system',
};
const jumpToDefaultValues = {
  jumpToCustomerId: '',
  jumpToPhoneNumber: '',
  jumpToEmail: '',
  jumpToExternalId: '',
  jumpToName: '',
};

export default {
  name: 'headerDefault',
  components: {
    agentEditor,
    TutorialIcon,
    Dropdown,
    AgentStatus,
    ThemeToggle,
  },
  emits: ['logout', 'changeAgentStatus'],
  computed: {
    ...mapState({
      agentProfile: state => state.agent.profile,
      agentConnection: state => state.agent.connection,
      permissions: state => state.agent.permissions,
      newConversationIndicator: state => state.conversations.newConversationIndicator,
      scope: state => state.conversations.scope,
      channel: state => state.conversations.channel,
      tutorialCompletionState: state => state.agent.tutorialCompletionState,
      totalLogins: state => state.agent.profile.totalLogins,
      config: state => state.configs.config,
      notifications: state => state.agent.notifications,
      FEATURE_FLAGS: state => state.featureFlags.FEATURE_FLAGS,
      userGuideConfig: state => state.configs.config.user_guiding,
      isMobileContext: state => state.settings.isMobileContext,
      contextNavText: state => state.settings.contextNavText,
      releaseNotesLink: state => state.configs.releaseNotesLink,
      allAgentStatusOptions: state => get(state, 'settings.agentStatuses.statuses', []),
    }),
    ...mapGetters({
      tutorialInProgress: 'agent/tutorialInProgress',
      isRepairModeEnabled: 'hidden/isRepairMode',
      changeHeaderForRepairMode: 'hidden/changeHeaderForRepairMode',
    }),
    shouldDisplaySettingsMenuItem() {
      return false;
    },
    shouldDisplayTutorialMenuItem() {
      return get(this.userGuideConfig, 'menu_to_launch', false);
    },
    shouldDisplaySchedulingJob() {
      return this.FEATURE_FLAGS.SHOW_SCHEDULING;
    },
    shouldDisplayMyPerformance() {
      return this.canView('/my/performance');
    },
    shouldDisplayReleaseNotesLink() {
      return this.canView('/help/release_notes');
    },
    isDarkThemeSupported() {
      return this.FEATURE_FLAGS.DARK_MODE;
    },
    agentStatusOptions() {
      const result = [];
      for (const agentStatus of this.allAgentStatusOptions) {
        result.push({
          id: agentStatus.status,
          label: agentStatus.label,
          status: agentStatus.status,
          subStatus: '',
        });
        for (const stubStatus of agentStatus.subStatuses) {
          if (stubStatus.selectable) {
            result.push({
              id: `${agentStatus.status}.${stubStatus.status}`,
              label: `${agentStatus.label} | ${stubStatus.label}`,
              status: agentStatus.status,
              subStatus: stubStatus.status,
            });
          }
        }
      }
      return result;
    },
    dropdownStatusOptions() {
      const result = [];
      const selectedStatus = get(this.selectedAgentStatus, 'status');
      const selectedSubStatus = get(this.selectedAgentStatus, 'subStatus');
      for (const agentStatus of this.allAgentStatusOptions) {
        const isStatusSelected = selectedStatus === agentStatus.status && selectedSubStatus === '';
        if (agentStatus.selectable && !isStatusSelected) {
          result.push({
            id: agentStatus.status,
            label: agentStatus.label,
            status: agentStatus.status,
            subStatus: '',
          });
        }
        for (const subStatus of agentStatus.subStatuses) {
          const isSubstatusSelected = agentStatus.status === selectedStatus && selectedSubStatus === subStatus.status;
          if (subStatus.selectable && !isSubstatusSelected) {
            result.push({
              id: `${agentStatus.status}.${subStatus.status}`,
              label: `${agentStatus.label} | ${subStatus.label}`,
              status: agentStatus.status,
              subStatus: subStatus.status,
            });
          }
        }
      }
      return result;
    },
    selectedAgentStatus: {
      get() {
        const status = get(this.agentProfile, 'available');
        const subStatus = get(this.agentProfile, 'busy_status.status');
        const agentStatus = this.agentStatusOptions.find(s => s.status === status && s.subStatus === subStatus);
        if (agentStatus) {
          return agentStatus;
        }
        return '';
      },
      set(newValue) {
        if (!has(newValue, 'status')) {
          return;
        }
        const newAgentStatus = { value: newValue.status, status: get(newValue, 'subStatus', '') };
        const isAlreadyAway = get(this.agentProfile, 'available') === FIXED_AGENT_STATUS.away.value;
        if (!isAlreadyAway && newValue.status === FIXED_AGENT_STATUS.away.value) {
          this.showAlert().then(data => {
            if (data) {
              this.$emit('changeAgentStatus', newAgentStatus);
            }
          });
        } else {
          this.$emit('changeAgentStatus', newAgentStatus);
        }
      },
    },
    avatar() {
      return get(this.agentProfile, 'picture.payload.url', defaultProfile.picture);
    },

    firstName() {
      return this.agentProfile.profile.first_name || defaultProfile.first_name;
    },

    lastName() {
      return this.agentProfile.profile.last_name || defaultProfile.last_name;
    },

    hasCustomerInNotification() {
      return Boolean(get(this.notificationItemOnPopup, 'payload.data.customer'));
    },

    customerNameInNotification() {
      return getCustomerName(get(this.notificationItemOnPopup, 'payload.data.customer'));
    },

    notificationMsg() {
      return get(this.notificationItemOnPopup, 'payload.body', '');
    },

    notificationMsgTitle() {
      return get(this.notificationItemOnPopup, 'payload.message', '');
    },
    jumpToFields() {
      const basetranslationKey = 'top_nav.lynq_to_button';
      return [
        { key: 'jumpToCustomerId', label: `${basetranslationKey}.lynq_id`, placeholder: `${basetranslationKey}.lynq_id_placeholder`, type: 'text' },
        { key: 'jumpToPhoneNumber', label: `${basetranslationKey}.phone_num`, placeholder: `${basetranslationKey}.phone_num_placeholder`, type: 'tel' },
        { key: 'jumpToEmail', label: `${basetranslationKey}.email`, placeholder: `${basetranslationKey}.email_placeholder`, type: 'email' },
        { key: 'jumpToExternalId', label: `${basetranslationKey}.external_id`, placeholder: `${basetranslationKey}.external_id_placeholder`, type: 'text' },
        { key: 'jumpToName', label: `${basetranslationKey}.name`, placeholder: `${basetranslationKey}.name_placeholder`, type: 'text' },
      ];
    },
    isGoToConversationDisabled() {
      if (this.loading) return true;

      const hasAnyInput = Object.values(this.jumpTo)
        .some(value => value.length > 0);
      if (!hasAnyInput) return true;

      return false;
    },
    isPhoneCallSupported() {
      return this.FEATURE_FLAGS.INBOUND_CALL;
    },
    isSmsSupported() {
      return this.FEATURE_FLAGS.ALLOW_SMS_CHANNEL_CUSTOMER_TAB_ACTIONS;
    },
  },
  data() {
    return {
      isLoading: false,
      agentStateVisible: false,
      profileEditorVisible: false,
      aiqLogo,
      showNotification: false,
      poll: null,
      notificationPagination: { ...PAGINATION_NOTIFICATION_DEFAULT },
      notificationItemOnPopup: null,
      isMobileMenuOpen: false,
      showJumpToPopUp: false,
      showConversationCreation: false,
      jumpTo: { ...jumpToDefaultValues },
      showProfileTooltip: true,
      showSetStatusDialog: false,
      loading: false,
    };
  },

  watch: {
    isMobileContext(newVal) {
      if (!newVal) {
        this.closeMobileMenu();
      }
    },
  },

  created() {
    if (this.FEATURE_FLAGS.ENABLE_NOTIFICATION) {
      this.getNotifications();
    }
  },

  async mounted() {
    if (this.FEATURE_FLAGS.ENABLE_NOTIFICATION) {
      this.startPoll();
    }

    if (this.FEATURE_FLAGS.USE_PUSH_NOTIFICATION) {
      this.startPushListener();
    }

    try {
      await this.$store.dispatch('settings/getSetting', { name: 'agent_status', stateName: 'agentStatuses' });
    } catch {
      this.$aiq.notify.error('Unable to fetch agent statuses');
    }

    if (get(this.agentProfile, 'busy_status.status') === 'logged_out') {
      // Due to some Agent IQ users setting their status to Available or Busy in prod, we set their status by default to Away.
      if (this.FEATURE_FLAGS.AIQ_DEFAULT_INITIAL_STATUS && isAgentIqEmailAddress(get(this.agentProfile, 'email'))) {
        this.$emit('changeAgentStatus', { value: FIXED_AGENT_STATUS.away.value, status: '' });
      } else {
        this.openSetStatusDialog();
      }
    }
  },

  beforeUnmount() {
    if (this.FEATURE_FLAGS.ENABLE_NOTIFICATION) {
      this.stopPollIfPolling();
    }
  },

  methods: {
    menuIndex(key) {
      return `${MENU_INDEX_PREFIX}${key}`;
    },

    goTo(path) {
      // Prevents redundant navigation by checking if the target path
      // is different from the current route. This avoids unnecessary
      // router.push calls and potential navigation errors/warnings
      // (e.g., "NavigationDuplicated" in Vue Router).
      if (this.$route.fullPath !== path) {
        this.$router.push(path);
      }
    },

    startPushListener() {
      // TODO: we may need to fetch config from backend
      this.$store.dispatch('push/init');
    },

    closeEditor() {
      this.jumpTo = { ...jumpToDefaultValues };
      this.showJumpToPopUp = false;
    },

    closeCreateConvEditor() {
      this.jumpTo = { ...jumpToDefaultValues };
      this.showConversationCreation = false;
    },
    handleBeforeClose() {
      if (this.isGoToConversationDisabled) {
        this.closeEditor();
        return;
      }
      confirmBeforeDialogClose(this, this.closeEditor);
    },
    handleConvBeforeClose() {
      confirmBeforeDialogClose(this, this.closeCreateConvEditor);
    },

    showJumpToUI() {
      this.showJumpToPopUp = true;
    },

    pushToConversation(customerId, queryParams = {}) {
      try {
        this.$router.push({
          name: 'ConversationByCustomerId',
          params: { id: customerId },
          query: queryParams,
        });
      } catch (err) {
        this.$aiq.notify.error(`Unable to route to the customer ${customerId}`);
      }
    },

    async createConversation() {
      try {
        const payload = {
          sms: this.jumpTo.jumpToPhoneNumber,
        };
        const customer = await this.$store.dispatch('conversations/createNewSMSCustomer', payload);
        this.closeConversationCreation();
        this.pushToConversation(customer.data.id);
      } catch (err) {
        const err_message = get(err, 'response.data.error') || 'Unable to create conversation' ;
        this.closeConversationCreation();
        this.$aiq.notify.error(err_message);
      }
    },
    async goToConversation() {
      const activeFilter = Object.keys(this.jumpTo).find(f => this.jumpTo[f].length > 0);

      if (activeFilter === 'jumpToCustomerId') {
        const customerId = this.jumpTo.jumpToCustomerId;
        this.closeJumpToUI();
        this.pushToConversation(customerId);
        return;
      }

      if (activeFilter === 'jumpToPhoneNumber') {
        if (this.isPhoneCallSupported || this.isSmsSupported) {
          await this.goToConversationByUniqueKey({
            action: 'conversations/fetchCustomerByPhone',
            value: this.jumpTo.jumpToPhoneNumber,
            onNotFound: () => {
              this.showConversationCreation = true;
            },
          });
          return;
        }

        await this.goToConversationByNonUniqueKey('phone', this.jumpTo.jumpToPhoneNumber);
        return;
      }

      if (activeFilter === 'jumpToEmail') {
        await this.goToConversationByNonUniqueKey('email', this.jumpTo.jumpToEmail);
        return;
      }

      if (activeFilter === 'jumpToExternalId') {
        await this.goToConversationByUniqueKey({
          action: 'conversations/fetchCustomerByExternalId',
          value: this.jumpTo.jumpToExternalId,
          onNotFound: () => {
            this.$aiq.notify.error('No conversation found with the provided External ID');
            this.closeJumpToUI();
          },
        });
        return;
      }

      if (activeFilter === 'jumpToName') {
        await this.goToConversationByNonUniqueKey('name', this.jumpTo.jumpToName);
        return;
      }
    },

    async goToConversationByUniqueKey({
      action,
      value,
      onNotFound,
    }) {
      try {
        const customer = await this.$store.dispatch(action, value);
        this.closeJumpToUI();

        const lynq_id = customer?.data?.id;
        this.pushToConversation(lynq_id);
      } catch (err) {
        if (err.status === NOT_FOUND) {
          onNotFound();
        } else {
          const errMessage =
            get(err, 'response.data.error') || 'Unable to navigate to conversation';
          this.$aiq.notify.error(errMessage);
          this.closeJumpToUI();
        }
      }
    },

    async goToConversationByNonUniqueKey(filterType, filterValue) {
      const queryParams = {
        'filter[query]': filterValue,
        'filter[filter_type]': filterType,
        limit: 1,
        order: 'desc',
      };

      try {
        this.loading = true;
        if (filterType === 'email' && !email.$validator(filterValue)) {
          throw new Error(this.$t('top_nav.lynq_to_button.email_error'));
        }
        const result = await this.$store.dispatch('conversations/search', queryParams);
        const rowCount = get(result, 'data.pagination.rowCount', 0);
        if (rowCount === 1) {
          const conversation = get(result, 'data.models[0]', {});
          this.pushToConversation(conversation.customer_id);
        } else {
          this.pushToConversation(undefined, { [filterType]: filterValue });
        }
      } catch (err) {
        const errMsg = err?.message || this.$t('top_nav.lynq_to_button.search_error');
        this.$aiq.notify.error(errMsg);
      } finally {
        this.loading = false;
        this.closeJumpToUI();
      }

    },

    closeConversationCreation() {
      this.showConversationCreation = false;
      this.closeJumpToUI();
    },

    closeJumpToUI() {
      this.showJumpToPopUp = false;
      this.jumpTo = { ...jumpToDefaultValues };
    },

    toogleBurger() {
      this.isMobileMenuOpen = !this.isMobileMenuOpen;
    },

    closeMobileMenu() {
      this.isMobileMenuOpen = false;
    },

    // [Vlad] This is hadrcode, it will be deleted when we will have finished
    isActive(sector) {
      return window.location.href.indexOf(sector) > -1;
    },
    showSchedulingJob() {
      // Close Smart Assist
      if (typeof window.__aiq !== 'undefined' && typeof window.__aiq.closeChatWindow === 'function') {
        window.__aiq.closeChatWindow();
      }

      this.$store.dispatch('agent/changeDialogVisibility', { name: 'schedulesDialog', visible: true, type: SCHEDULE_TYPE.CALENDAR });
    },
    redisplayTutorial() {
      this.$store.dispatch('notifications/emitEventToSocket', {
        name: AGENT_ONBOARDING.MANUAL_OPEN,
        payload: {
          agent: this.agentProfile,
          config: this.userGuideConfig,
        },
      });

      this.$store.dispatch('agent/showTutorial');
    },
    logout() {
      // When you logout, remove the current tab from the active tabs list
      removeCurrentTab();

      this.$emit('logout');
    },
    showAlert(title, text) {
      title = title || 'Status Confirmation';
      text = text || 'Selecting Away unlocks your conversations. <br> Do you want to proceed?';

      return new Promise(resolve => {
        this.$aiq.confirm(title, text, {
          cancelButtonText: 'Cancel',
          confirmButtonText: 'Make Away',
        })
          .then(() => resolve(true), () => resolve(false));
      });
    },

    showProfileEditor() {
      this.$store.dispatch('agents/selectAgent', this.agentProfile)
        .then(() => {
          this.profileEditorVisible = true;
        });
    },

    closeProfileEditor() {
      this.profileEditorVisible = false;
    },

    onNewConversationIndicatorClick() {
      Promise.all([
        this.$store.dispatch('conversations/updateNewConversationIndicator'),
        this.$store.dispatch('conversations/setScope', DEFAULT_SCOPE),
        this.$store.dispatch('conversations/setChannel', 'all'),
      ]).then(() => {
        this.$store.dispatch('conversations/list', {
          channel: 'all', scope: 'mine',
        });
      });
    },
    closeProfileSubmenu() {
      this.$refs.headerMenuItem.close(this.menuIndex('profile'));
    },
    onCloseProfileSubMenu() {
      this.closeProfileSubmenu();
      this.showProfileTooltip = true;
    },
    onVisibilityChanged(val) {
      this.agentStateVisible = val;
    },
    onAgentStatusClick() {
      this.closeProfileSubmenu();
    },
    async onNotificationClick() {
      // Close Smart Assist
      if (typeof window.__aiq !== 'undefined' && typeof window.__aiq.closeChatWindow === 'function') {
        window.__aiq.closeChatWindow();
      }

      this.showNotification = !this.showNotification;

      this.$store.dispatch(
        'notifications/emitEventToSocket',
        { name: NOTIFICATIONS.BELL_CLICKED,
          payload: {
            agent: this.$store.getters['agent/profile'],
            received: this.notificationPagination.rowCount,
            unread_count: this.notifications.unread_count,
          },
        },
      );
    },
    onCloseNotification() {
      this.showNotification = false;
    },
    async onSelectNotification(item) {
      const reminder = {
        name: 'selectNotification',
        type: SCHEDULE_TYPE.NOTIFICATIONS,
      };
      await this.$store.dispatch('agent/markReadNotification', { notification: item, reminder });
      await this.getNotifications();
      this.onCloseNotification();

      const notificationType = get(item, 'payload.type');
      if (notificationType === NOTIFICATION_TYPE.CUSTOMER) {
        const customerId = get(item, 'payload.sender_id');
        this.$router.push({
          name: 'ConversationByCustomerId',
          params: { id: customerId },
        });
      } else if (notificationType === NOTIFICATION_TYPE.AGENT) {
        this.notificationItemOnPopup = item;
      }
    },
    async onReadAllNotifications() {
      await this.$store.dispatch('agent/readAllNotification');
      await this.getNotifications();
    },
    async onDeleteNotification(item) {
      const reminder = {
        name: 'deleteNotification',
        type: SCHEDULE_TYPE.NOTIFICATIONS,
      };
      await this.$store.dispatch('agent/deleteNotification', { notification: item, reminder });
    },
    async onNextNotifications({ done, complete }) {
      const { offset, limit, pageCount, rowCount } = this.notificationPagination;
      const newOffset = offset + limit;
      if (newOffset >= rowCount) {
        complete();
        return;
      }

      await this.getNotifications({ offset: newOffset, limit, pageCount, rowCount });

      // ugly handling infinite loading with done and complete callbacks.
      done();
      if (this.notificationPagination.rowCount === this.notifications.items.length) {
        complete();
      }
    },
    startPoll() {
      this.stopPollIfPolling();
      const resetNotifications = async() => {
        try {
          await this.getNotifications();
        } catch (err) {
          this.$aiq.notify.error('Unable to fetch notification');
        }
        if (this.poll) {
          this.poll = setTimeout(resetNotifications, DEFAULT_POLL_INTERVAL);
        }
      };
      this.poll = setTimeout(resetNotifications, DEFAULT_POLL_INTERVAL);
    },

    stopPollIfPolling() {
      if (this.poll) {
        const poll = this.poll;
        this.poll = null;
        clearTimeout(poll);
      }
    },

    async getNotifications(newPagination) {
      if (this.isLoading) {
        return;
      }
      this.isLoading = true;
      const targetPagination = assign({}, PAGINATION_NOTIFICATION_DEFAULT, newPagination);
      const data = await this.$store.dispatch('agent/getNotifications', targetPagination);
      this.notificationPagination = data.pagination;
      if (!newPagination && this.$refs.notificationDropdown) {
        // reset notifications, so need to reset infinite loading
        this.$refs.notificationDropdown.resetInfiniteLoading();
      }
      this.isLoading = false;
      return data;
    },

    goToCustomerConversation() {
      const customer = get(this.notificationItemOnPopup, 'payload.data.customer');
      this.notificationItemOnPopup = null;
      if (customer) {
        this.$router.push({
          name: 'ConversationByCustomerId',
          params: { id: customer.id },
        });
      }
    },

    getIsJumpToFilterDisabled(filterProperty) {
      return Object.keys(this.jumpTo)
        .some(f => f !== filterProperty && this.jumpTo[f].length > 0) || this.loading;
    },

    showSettings() {
      this.$router.push('/settings');
    },

    openReleaseNotesLink() {
      const queryString = this.agentConnection ? `?connection=${this.agentConnection}` : '';
      window.open(`${this.releaseNotesLink}${queryString}`, '_blank');
    },

    onThemeChanged(/* theme */) {
      // Handle theme change event if needed
      // console.log(`Theme changed to: ${theme}`);

      // You can add any additional logic here, such as:
      // - Updating user preferences on the server
      // - Triggering other theme-related actions
      // - Analytics tracking
    },

    handleInitialStatusSelect() {
      this.showSetStatusDialog = false;
    },

    canAccessRoute(path) {
      return this.canView(path) && this.$router.getRoutes().some(r => r.path === path);
    },

    openSetStatusDialog() {
      this.showSetStatusDialog = true;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../styles/aiq-variables.scss";
@import "../../styles/media-queries.scss";

$scale-duration: 1.2;
$unread-message-indicator-size: 24px;
$unread-message-indicator-color: #E65BB3;

@keyframes glowing {
  0% {
    transform: scale($scale-duration);
  }

  40% {
    transform: scale(1);
  }

  60% {
    transform: scale($scale-duration);
  }

  100% {
    transform: scale($scale-duration);
  }
}

.nav-wrapper {
  #menu {
    &.repair-mode {
      .main-toolbar {
        background-color: red;
      }
    }

    header {
      position: relative;

      #toggle {
        position: absolute;
        top: 14px;
        left: 20px;
        z-index: 999;
        width: 30px;
        height: 40px;
        cursor: pointer;
        visibility: hidden;
        opacity: 0;
        transition: all 0.3s ease-out;

        .span {
          border-radius: 10px;
          background: white;
          transition: all 0.3s ease-out;
          backface-visibility: hidden;
        }

        #top.span.active {
          transform: rotate(45deg) translateX(3px) translateY(5px) !important;
        }

        #middle.span.active {
          opacity: 0;
        }

        #bottom.span.active {
          transform: rotate(-45deg) translateX(8px) translateY(-10px) !important;
        }
      }

      .main-toolbar {
        display: flex;
        justify-content: space-between;
        height: 64px;
        min-height: 64px;
        padding: 0 20px 0 20px;
        font-weight: 500;
        background-color: $aiq-bgc-header;

        .glow-ico-message {
          &::before {
            background: initial;
          }
        }

        .main-toolbar_item,
        .logo-dropdown-container,
        .icon-container,
        .mobileNavPageName {
          height: 100%;
          border-bottom: 0;
        }

        .main-toolbar_item {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 99px;
          padding: 0;
          line-height: initial;

          &:hover {
            background-color: transparent;

            > a {
              opacity: 1;
            }
          }

          > a {
            display: flex;
            flex-flow: column wrap;
            width: 100%;
            height: 100%;
            padding-top: 13px;
            color: #fff;
            font-size: 12px;
            line-height: 12px;
            font-weight: 300;
            text-align: center;
            opacity: 0.75;

            [class^="iq-ico"] {
              margin-bottom: 6px;
            }

            &:hover {
              color: #fff;
            }

            &[class*="active"] {
              opacity: 1;
              background-color: rgba(70, 113, 179, 0.4);
            }
          }

          .unread-message {
            position: absolute;
            top: 11px;
            display: flex;
            align-items: center;
            justify-content: center;
            width: $unread-message-indicator-size;
            height: $unread-message-indicator-size;

            &-indicator {
              position: absolute;
              width: $unread-message-indicator-size;
              height: $unread-message-indicator-size;
              border-radius: 50%;
              background: radial-gradient(
                $unread-message-indicator-color,
                rgba($unread-message-indicator-color, 0.5)
              );
            }
          }

          .button-glow {
            animation: glowing 1500ms infinite;
          }
        }

        .agent-status-menu {
          justify-content: initial;
          width: 135px;
          margin-right: 0;

          .status-available {
            &::before {
              margin-top: -5px;
            }
          }

          &.sub-status {
            flex: 0 0 250px;

            :deep(.status-indicator) {
              &::before {
                width: 12px;
                height: 12px;
              }
            }

            :deep(.el-select) {
              .el-select__wrapper {
                background-color: transparent !important;
                box-shadow: none !important;
                border-color: unset !important;
              }

              .el-select__selection {
                .el-select__placeholder {
                  width: 180px;
                }

                .el-select__selected-item {
                  color: var(--aiq-color-white) !important;
                }
              }

              .el-select__suffix {
                width: 20px;
                margin-left: 0 !important;
              }
            }
          }
        }

        .logo-dropdown-container {
          display: flex;
          align-items: center;
          justify-content: flex-end;
          flex-grow: 1;
          min-width: 219px;
          margin-right: 15px;
          padding: 0;

          &:active,
          &:focus,
          &:hover {
            background-color: transparent;
          }

          .aiq-logo {
            width: 93px;
            height: 14px;
            margin-bottom: -3px;
          }
        }

        .mobileNavPageName {
          display: none;
          align-items: center;
          justify-content: center;
          flex-grow: 1;
          padding: 0 0 0 55px;
          line-height: initial;
          color: white;

          &:active,
          &:focus,
          &:hover {
            opacity: 1;
            color: white;
            background-color: transparent;
          }

          .contextNavText {
            font-size: 16px;
            font-weight: 100;
            line-height: 17px;
          }
        }

        .icon-container {
          position: relative;
          padding: 18px 0 15px 10px;

          &:active,
          &:focus,
          &:hover {
            background-color: transparent;
          }

          .notification-button {
            cursor: pointer;
          }

          .notification-badge {
            position: absolute;
            top: 0;
            right: -5px;

            :deep(.el-badge__content) {
              border-color: transparent;
              z-index: 1000;
            }
          }

          .notification-icon,
          .arrow-right {
            color: white;
            opacity: 0.75;

            &:hover {
              opacity: 1;
            }
          }

          .notification-icon {
            width: 22px;
            height: 25px;
            stroke: white;
          }

          .arrow-right {
            width: 25px;
            height: 25px;
            margin-top: 3px;
            outline: none;
            box-shadow: none;
          }

          .calendar {
            width: 21px;
            height: 25px;
            cursor: pointer;
            color: white;
            opacity: 0.75;

            &:hover {
              opacity: 1;
            }
          }
        }

        .dropdown {
          margin-left: 15px;

          .el-button {
            min-width: 0;
            margin: 0;
            padding: 0;
          }

          img {
            width: 28px;
            height: 28px;
            border-radius: 50%;
          }

          span {
            margin-left: 8px;
            font-size: 12px;
            line-height: 12px;
            text-transform: none;
          }

          .avatar-status-indicator {
            margin-left: -10px;
            margin-bottom: -5px;
            display: none;
          }

          .profile-name {
            min-width: 0;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            line-height: 28px;
          }
        }
      }
    }
  }

  .dialog-conv-footer {
    padding-top: 10px;
    text-align: right;
  }
}

.tutorial-text {
  margin-left: 8px !important;
}

.phone-content {
  margin-bottom: 5px;
}

.dialog-content {
  &:not(:first-child) {
    padding-top: 15px;
  }
  margin-bottom: 5px;
  font-size: 14px;
}

.customer-reference {
  display: inline-block;

  .label {
    display: inline-block;
    padding: 10px 10px 0 0;
  }

  .value {
    float: right;
    padding: 10px 0;
  }
}

.calendar-icon {
  margin: 3px;
  font-size: 25px;
  color: white;
  cursor: pointer;
}

.besek {
  svg {
    margin-right: 5px;
  }
}

:deep(.lynq-input input) {
  font-size: 14px;

  &::placeholder {
    font-size: 14px;
  }
}

:deep(.mobile-menu-drawer) {
  height: fit-content !important;
  z-index: 99999;
  top: 64px;

  .el-drawer__body {
    padding: 0;

    .el-menu-item {
      display: flex;
      align-items: center;
      justify-content: center;
      color: #fff;
      background-color: $aiq-bgc-header;
      font-size: 20px;
      font-weight: 100;

      &:hover {
        opacity: 0.9;
      }
    }
  }
}



@include mobile{
  .nav-wrapper {
    position: fixed;
    top: 0;
    z-index: 100;
    width: 100%;

    #menu {
      header {
        .main-toolbar {
          .main-toolbar_item,
          .logo-dropdown-container,
          .icon-container {
            display: none;
          }

          .mobileNavPageName {
            display: flex;
          }

          .agent-status.avatar-status-indicator  {
            display: block;
          }

          .profile-name {
            display: none;
          }
        }

        #toggle {
          visibility: visible;
          opacity: 1;
          margin-top: 6px;

          .span {
            height: 4px;
            margin: 5px 0;
            visibility: visible;
            opacity: 1;
            transition: all 0.3s ease;
            backface-visibility: visible;
          }
        }
      }
    }
  }
}
</style>

